import React, { useState } from "react";
import clsx from "clsx";
import { CircularProgress } from "@material-ui/core";
import { toast } from "react-toastify";

import apiV2 from "../../services/apiV2";
import toastError from "../../errors/toastError";
import { i18n } from "../../translate/i18n";
import { emitTicketAiReportCreated } from "../../helpers/ticketAiReportEvents";

export default function TicketAiReportPanel({
	ticketId,
	tailwickLayout = false,
}) {
	const [loading, setLoading] = useState(false);

	const handleGenerate = async () => {
		if (!ticketId || loading) return;
		setLoading(true);
		try {
			const { data } = await apiV2.post(`/tickets/${ticketId}/ai-reports`);
			emitTicketAiReportCreated(ticketId, data);
			toast.success(i18n.t("messagesInput.aiReport.generatedSuccess"));
		} catch (err) {
			console.error(err);
			toastError(err);
		} finally {
			setLoading(false);
		}
	};

	return (
		<div
			className={clsx(
				tailwickLayout
					? "tailwick-ai-report-panel px-3 pb-3"
					: "border-t border-default-200 bg-white px-3 py-3 dark:border-default-700 dark:bg-default-900"
			)}
		>
			<div
				className={clsx(
					"rounded-2xl border px-3 py-3",
					"border-violet-200 bg-violet-50 text-violet-950",
					"dark:border-violet-700/50 dark:bg-violet-950/40 dark:text-violet-100"
				)}
			>
				<p className="m-0 mb-1 text-sm font-semibold">
					{i18n.t("messagesInput.aiReport.panelTitle")}
				</p>
				<p className="m-0 mb-3 text-xs leading-5 opacity-90">
					{i18n.t("messagesInput.aiReport.panelHint")}
				</p>
				<button
					type="button"
					onClick={handleGenerate}
					disabled={loading || !ticketId}
					className={clsx(
						"inline-flex w-full items-center justify-center gap-2 rounded-xl px-3 py-2.5 text-sm font-semibold transition",
						"bg-violet-600 text-white hover:bg-violet-700",
						"disabled:cursor-not-allowed disabled:opacity-60"
					)}
				>
					{loading ? (
						<>
							<CircularProgress size={16} color="inherit" />
							{i18n.t("messagesInput.aiReport.generating")}
						</>
					) : (
						i18n.t("messagesInput.aiReport.generate")
					)}
				</button>
			</div>
		</div>
	);
}
